const state = {
    designations: [],
    designationId: [],
    loading: false
};

export default state;